/**
 * Usage:
 *
 * In template:
 * <div v-loading></div>
 *
 * // show loading mask status
 * this.$emit('loading.start')
 *
 * // hide
 * this.$emit('loading.end')
 *
 * Custom style:
 * .loading-status {}
 */
import Vue from 'vue'
import store from 'store'
Vue.directive('loading', {
  bind(el, binding, vnode) {
    const div = document.createElement('div')
    const span = document.createElement('span')
    if (binding.modifiers.absolute) {
      div.style.position = 'absolute'
      div.style.top = '0'
      div.style.left = '0'
      div.style.width = '100%'
      div.style.height = '100%'
    } else {
      div.style.position = 'fixed'
    }
    div.style.pointerEvents = 'none'
    div.style.display = 'none'
    div.className = 'v-loading'
    span.style.position = 'absolute'
    span.style.top = '50%'
    span.style.left = '50%'
    span.style.marginTop = '-30px'
    span.style.marginLeft = '-30px'
    span.className = 'tt-loading'
    div.appendChild(span)
    el.appendChild(div)
    vnode.context.$on('loading.start', () => {
      if (el.dataset.loading === 1) return
      el.dataset.loading = 1
      span.className = `tt-loading tt-loading-${store.getters.theme}`
      if (binding.modifiers.absolute) {
        const pos = window.getComputedStyle(el).position || 'static'
        if (pos === 'static') {
          el.style.position = 'relative'
        }
        div.style.display = 'block'
      } else {
        const elRect = el.getBoundingClientRect()
        div.style.display = 'none'
        div.style.width = elRect.width + 'px'
        div.style.height = elRect.height + 'px'
        div.style.top = elRect.top + 'px'
        div.style.left = elRect.left + 'px'
        div.style.display = 'block'
      }
    })

    vnode.context.$on('loading.end', () => {
      div.style.display = 'none'
      el.dataset.loading = ''
    })
    if (binding.modifiers.immediate) {
      vnode.context.$emit('loading.start')
    }
  },
  update(el, binding, vnode) {
    if (vnode.context) {
      if (binding.value) {
        vnode.context.$emit('loading.start')
      } else {
        vnode.context.$emit('loading.end')
      }
    }
  },
  unbind(el, binding, vnode) {
    vnode.context.$off(['loading.start', 'loading.end'])
  }
})
